import React from 'react';

// Slim chart container used by every canvas view. Keeps spacing,
// typography and right-aligned meta consistent across views.
export default function ChartFrame({ title, subtitle, right, children, footer }) {
  return (
    <div className="flex h-full min-h-0 flex-col">
      {(title || subtitle || right) ? (
        <div className="mb-2 flex items-start justify-between gap-2">
          <div className="min-w-0">
            {title ? <h4 className="text-[12px] font-semibold text-zinc-900">{title}</h4> : null}
            {subtitle ? <p className="truncate text-[11px] text-zinc-500">{subtitle}</p> : null}
          </div>
          {right ? <div className="shrink-0">{right}</div> : null}
        </div>
      ) : null}
      <div className="min-h-0 flex-1">{children}</div>
      {footer ? <div className="mt-2 text-[10.5px] text-zinc-500">{footer}</div> : null}
    </div>
  );
}

export const TOOLTIP_STYLE = {
  fontSize: 11,
  borderRadius: 6,
  border: '1px solid #e4e4e7',
  background: '#ffffff',
  boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
};

export const CHART_PALETTE = ['#6366f1', '#0ea5e9', '#14b8a6', '#f59e0b', '#f43f5e', '#8b5cf6'];
